import OutlookIcon from "assets/icons/outlook.png";
import WhatsAppIcon from "assets/icons/whatsapp.png";
import InstagramIcon from "assets/icons/instagram.png";
import LinkedInIcon from "assets/icons/linkedin.png";

const listSkill = [
  "Merancang desain antarmuka aplikasi dan wesbite menggunakan Figma",
  "Membangun aplikasi berbasis mobile menggunakan framework Flutter",
  "Membangun aplikasi berbasis website menggunakan framework ReactJS",
  "Membangun aplikasi multiplatform beserta perancangan database menggunakan Firebase",
  "Melakukan pengoperasian database menggunakan query SQL",
  "Mengoperikan software dokumen seperti Microsoft Office",
];

const listContact = [
  {
    icon: OutlookIcon,
    text: "ranggawiragunar@gmail.com",
    link: "mailto:ranggawiragunar@gmail.com",
  },
  {
    icon: WhatsAppIcon,
    text: "0815-1148-2987",
    link: "https://wa.me/+6281511482987",
  },
];

const listSocialMedia = [
  {
    icon: InstagramIcon,
    text: "ranggapx_",
    link: "https://www.instagram.com/ranggapx_",
  },
  {
    icon: LinkedInIcon,
    text: "ranggawiragunar",
    link: "https://www.linkedin.com/in/ranggawiragunar",
  },
];

const educationPathInitial = { scale: 0, opacity: 0 };
const educationPathAnimate = { scale: 1, opacity: 1 };
const educationLineInitial = { pathLength: 0, opacity: 0 };
const educationLineAnimate = { pathLength: 1, opacity: 1 };


export {
  listSkill,
  listContact,
  listSocialMedia,
  educationPathInitial,
  educationPathAnimate,
  educationLineInitial,
  educationLineAnimate,
};
